import React, { Component, } from "react"
import Grid from '@mui/material/Grid';

import {
   Button,
   Typography,
} from "@mui/material";
import axios from "axios";

const paths = require('../../paths.json');

const smallHeading = {
   color: '#000',
   fontSize: '15px',
   fontWeight: '600',
   margin: '0px auto 5px 0px',
   display: 'block',
}

const smallDescription = {
   color: '#6E89AF',
   fontSize: '14px',
   fontWeight: '500',
   margin: '0px auto 0px 0px',
   display: 'block',
}

class CreatorBilling extends Component {
   constructor(props) {
      super(props);
      this.state = {
         link_url: '',
         isLoading: true,
      };
   }

   componentDidMount() {
      this.setState({ isLoading: true });
      axios({
         method: 'get',
         url: paths.BACKEND_URL + "api/settings_page_creator_billing_info",
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      }).then(res => {
         this.setState({ link_url: res.data.link_url, isLoading: false });
      })
   }


   render() {
      return (
         <div>
            <Typography style={{ color: '#222222', fontSize: '26px', fontWeight: '600', paddingBottom: this.state.error === 'account not completed' ? '20px' : '0px', }}>Billing</Typography>

            <Grid
               Container
               xs={12}
            >
               <Grid container>
                  <Grid xs={12} sx={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #E4EBF6', marginTop: '20px' }}>
                     <span style={smallHeading}>
                        Manage Billing
                     </span>
                     <span style={smallDescription}>
                        Manage your WithMe subscription, including modifying or canceling your plan.
                     </span>

                     <Button
                        disableRipple
                        variant="contained"
                        sx={{
                           backgroundColor: 'var(--brand-color)',
                           fontSize: '14px',
                           textTransform: 'none',
                           boxShadow: 'none',
                           marginTop: '20px',
                           borderRadius: '8px',
                           fontWeight: '600',
                           ':hover': {
                              backgroundColor: 'var(--brand-color-hover)',
                              color: 'white',
                              boxShadow: 'none',
                           },
                        }}
                        onClick={() => {
                           setTimeout(() => {
                              window.open(this.state.link_url)
                           }, 800);
                        }}>
                        Go to Billing Portal
                     </Button>
                  </Grid>
               </Grid>
            </Grid>
         </div>
      )
   }
}

export default CreatorBilling;